import type { AppState, Language, Payload } from 'store/state';

export function changeLanguageAction(state: AppState, payload: Payload): AppState {
	return {
		...state,
		language: {
			...state.language,
			...payload.language
		}
	};
}

export function translationsAction(state: AppState, payload: Payload): AppState {
	const LANG = payload.language?.language as Language;
	return {
		...state,
		language: {
			...state.language,
			translations: {
				...state.language.translations,
				[LANG]: {
					...state.language.translations[LANG],
					...payload.language?.translations
				}
			}
		}
	};
}
